import { debounce } from 'lodash-es';

import { postRecommendedItemTrack } from 'features/tealium/dynamicYield/api';

import { getDySessionId, isDyProductRecommendationsEnabled } from '../helpers';

function trackDyRecommendedItemClickEvent ({ selector, debounceTime = 200 }) {

	if (isDyProductRecommendationsEnabled()) {

		selector.forEach((element) => {

			element.addEventListener('click', debounce(() => {

				const decisionId = element.closest('[data-decisionid]')?.getAttribute('data-decisionid');
				const dataSlotId = element.getAttribute('data-slotid');

				postRecommendedItemTrack({
					SlotId: dataSlotId,
					DecisionId: decisionId,
					DySessionId: getDySessionId()
				});

			}, debounceTime));

		});

	}

}

export default trackDyRecommendedItemClickEvent;
